import VendorBillPage from "./VendorBillPage";

export default function StoreRentPaymentPage() {
  return (
    <VendorBillPage
      moduleKey="store-rent"
      moduleName="store_rent"
      title="Store Rent Payment"
      route="store-rent-payments"
      columns={[
        { field: "store_location", label: "Store Location", placeholder: "e.g. Andheri Store" },
        { field: "rent_period",    label: "Rent Period",    placeholder: "e.g. Apr-26" },
        { field: "ref_no",         label: "Invoice / Ref No", placeholder: "e.g. INV/2026/045" },
      ]}
    />
  );
}
